;(function ($) {
  "use strict"

  let isUpdating = false

  function updateAddParticipantButton() {
    if (isUpdating) return
    isUpdating = true

    const currentLanguage = document.documentElement.lang
    const transRemove = {
      "en-US": "Remove",
      et: "Eemalda",
    }
    const transAddParticipant = {
      "en-US": "Add participant",
      et: "Lisa osaleja",
    }
    const iconRemove =
      "<svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#e8eaed'><path d='M640-520v-80h240v80H640Zm-280 40q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm80-80h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0-80Zm0 400Z'/></svg>"
    const iconAdd =
      "<svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#e8eaed'><path d='M720-400v-120H600v-80h120v-120h80v120h120v80H800v120h-80Zm-360-80q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm80-80h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0-80Zm0 400Z'/></svg>"

    $(".wpcf7-field-group-remove").each(function () {
      const $button = $(this)

      if (!$button.html().includes(transRemove[currentLanguage])) {
        $button.html(iconRemove + transRemove[currentLanguage])
      }
    })

    $(".wpcf7-field-group-add").each(function () {
      const $button = $(this)

      if (!$button.html().includes(transAddParticipant[currentLanguage])) {
        $button.html(iconAdd + transAddParticipant[currentLanguage])
      }
    })

    isUpdating = false
  }

  function calculatePrice() {
    const selectedValue = $(
      "input[type=radio][name=selected_type]:checked",
    ).val()
    let price = 0
    if (selectedValue !== "") {
      const hiddenField = $(
        "input[name^='tasuline_hind_" + selectedValue + "']",
      )

      if (hiddenField.length) {
        price = parseFloat(hiddenField.val()) || 0
      }
    }

    // Calculate the number of participant input fields
    let participantCount = $('input[name^="participants_name__"]').length

    // Multiply price by participant count
    const totalPrice = price * participantCount

    // Output the result
    $(".event-price").text(totalPrice)
  }

  $(document).ready(function () {
    updateAddParticipantButton()

    // Calculate price initially and on radio button change
    $("input[type=radio][name=selected_type]").change(calculatePrice)

    const $participantsContainer = $('div[data-id="participants-repeater"]')

    if ($participantsContainer.length) {
      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(function (mutationsList, observer) {
        for (let mutation of mutationsList) {
          if (mutation.type === "childList") {
            updateAddParticipantButton()
            calculatePrice()
          }
        }
      })

      // Start observing the target node for configured mutations
      observer.observe($participantsContainer[0], {
        childList: true,
        subtree: true,
      })
    }

    // Also calculate price if participant input values change
    $(document).on(
      "input",
      'input[name^="participants_name__"]',
      calculatePrice,
    )
  })
})(jQuery)

document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    const response = event.detail.apiResponse

    // Check if the form is the Estonian or English events form
    if (
      response.contact_form_id === 16738 ||
      response.contact_form_id === 17816
    ) {
      window.location.href = response.redirect_url
    }
  },
  false,
)
